import * as z from "zod";

/**
 * Emails the calling user a one-click login link for their computer, at most
 * once a day, if their team self-onboarded to OMS (`eligible`). `resend` asks
 * for another link now, limited to one a minute instead. `credit` is
 * the onboarding credit terms the email mentions, or null when the team can't
 * earn the credit and nothing should mention it.
 */
export const sendDesktopLoginLink = {
  name: "sendDesktopLoginLink" as const,
  input: z.object({
    nextPath: z.string().optional(),
    resend: z.boolean().optional(),
  }),
  output: z.object({
    eligible: z.boolean(),
    sent: z.boolean(),
    credit: z
      .object({ capUsd: z.number(), requiredFulfillments: z.number() })
      .nullable(),
  }),
};
